import { render, staticRenderFns } from "./recognitionsListManage.vue?vue&type=template&id=53bf2f2c"
import script from "./recognitionsListManage.vue?vue&type=script&lang=js"
export * from "./recognitionsListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports